var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeneralSafety3Icon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 16.3333C10.878 16.4918 11.1239 16.5977 11.3842 16.6425C11.6444 16.6873 11.9116 16.6696 12.1637 16.5908C12.4158 16.5121 12.6455 16.3746 12.834 16.1896C13.0225 16.0047 13.1644 15.7776 13.2479 15.527C13.3314 15.2765 13.3542 15.0097 13.3144 14.7486C13.2745 14.4876 13.1732 14.2397 13.0188 14.0255C12.8644 13.8112 12.6613 13.6367 12.4262 13.5164C12.1911 13.3961 11.9308 13.3333 11.6667 13.3333H1.66675",
    stroke: "#525252",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5834 6.66665C14.7965 6.38255 15.0786 6.15764 15.4031 6.01326C15.7275 5.86889 16.0835 5.80984 16.4372 5.84173C16.7909 5.87362 17.1305 5.99539 17.4239 6.19548C17.7173 6.39557 17.9547 6.66732 18.1135 6.98495C18.2723 7.30258 18.3473 7.65553 18.3313 8.01029C18.3153 8.36505 18.209 8.70984 18.0223 9.01192C17.8356 9.314 17.5748 9.56335 17.2646 9.73628C16.9544 9.90921 16.6052 9.99998 16.2501 9.99998H1.66675",
    stroke: "#525252",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16675 3.66665C8.37802 3.50819 8.62392 3.40222 8.88418 3.35744C9.14444 3.31267 9.41162 3.33038 9.66369 3.40912C9.91577 3.48787 10.1455 3.62538 10.334 3.81034C10.5225 3.9953 10.6644 4.2224 10.7479 4.47293C10.8314 4.72347 10.8542 4.99026 10.8144 5.25133C10.7745 5.51239 10.6732 5.76026 10.5188 5.9745C10.3644 6.18873 10.1613 6.36321 9.92622 6.48355C9.69114 6.60389 9.43083 6.66665 9.16675 6.66665H1.66675",
    stroke: "#525252",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralSafety3Icon);
export default __webpack_public_path__ + "static/media/general_safety_3_icon.43fe7cac6eb91fe3fe9d792f50937340.svg";
export { ForwardRef as ReactComponent };